// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"3d595773","455":"f12aa7ed","709":"8002a858"}[chunkId] + ".chunk.js";
};